type HexchainInteractionTile = { color: number; age: number; frozen: boolean };
type HexchainInteractionPlayer = { alive: boolean; board: HexchainInteractionTile[] };
type HexchainInteractionRoom = {
  gameType?: string;
  phase?: string;
  hexchain?: { players: Record<string, HexchainInteractionPlayer> };
};

let gestureActive = false;
let refreshDeferred = false;
let animationActive = false;

function boardKey(player: HexchainInteractionPlayer | undefined) {
  return player?.board.map((tile) => `${tile.color}:${tile.age}:${Number(tile.frozen)}`).join("|") || "";
}

export function beginHexchainGesture() {
  gestureActive = true;
}

export function endHexchainGesture() {
  gestureActive = false;
  const shouldRefresh = refreshDeferred;
  refreshDeferred = false;
  return shouldRefresh;
}

export function resetHexchainInteraction() {
  gestureActive = false;
  refreshDeferred = false;
  animationActive = false;
}

export function beginHexchainAnimation() {
  animationActive = true;
}

export function endHexchainAnimation() {
  animationActive = false;
  const shouldRefresh = refreshDeferred;
  refreshDeferred = false;
  return shouldRefresh;
}

export function shouldDeferHexchainRender(previous: HexchainInteractionRoom | null, next: HexchainInteractionRoom, playerId: string) {
  if ((!gestureActive && !animationActive) || previous?.gameType !== "hexchain" || next.gameType !== "hexchain") return false;
  if (previous.phase !== "hexchain_battle" || next.phase !== "hexchain_battle") return false;
  if (animationActive) {
    refreshDeferred = true;
    return true;
  }
  const previousPlayer = previous.hexchain?.players[playerId];
  const nextPlayer = next.hexchain?.players[playerId];
  if (!previousPlayer?.alive || !nextPlayer?.alive || boardKey(previousPlayer) !== boardKey(nextPlayer)) return false;
  refreshDeferred = true;
  return true;
}

export function isHexchainGestureActive() {
  return gestureActive;
}

export function isHexchainAnimationActive() {
  return animationActive;
}
